import request from '../utils/request';

// 定制服务请求 API
export const customServiceRequestApi = {
  // 分页查询定制服务需求
  // params: { pageNum, pageSize, userStatus, platformStatus, userId, keyword, minPrice, maxPrice, adminId, sortField, sortOrder }
  getCustomServiceRequestPage: (params) => request.get('/custom-service-request/page', { params }),
  
  // 获取定制服务需求详情
  getCustomServiceRequestDetail: (requestId) => request.get(`/custom-service-request/detail/${requestId}`),
  
  // 更新定制服务需求
  // data: { requestId, description, referenceImages, expectedPrice, contact }
  updateCustomServiceRequest: (data) => request.put('/custom-service-request/update', data),
  
  // 删除定制服务需求
  deleteCustomServiceRequest: (requestId) => request.delete(`/custom-service-request/delete/${requestId}`),
  
  // 审核定制服务需求
  // data: { requestId, adminId, approved }
  reviewCustomServiceRequest: (data) => request.post('/custom-service-request/review', data),
  
  // 开始服务
  // data: { requestId, adminId }
  startService: (data) => request.post('/custom-service-request/start-service', data),
  
  // 完成服务
  // requestId: 需求ID
  completeService: (requestId) => request.post(`/custom-service-request/complete-service/${requestId}`),
  
  // 创建定制服务需求
  // data: { userId, description, referenceImages, expectedPrice, contact, adminId, reviewRemark }
  createCustomServiceRequest: (data) => request.post('/custom-service-request/create', data)
}; 